import React from 'react';
import { IconButton, Stack, Switch } from "@mui/material";
import { Edit } from "@mui/icons-material";

const EditableLabel: React.FC<EditableLabelProps> = props => {
    const [checked, setChecked] = React.useState(props.initialChecked);
    return (
        <Stack direction='row' spacing={ 1 } alignItems='center'>
            <span style={ { whiteSpace: 'nowrap' } }>{ props.label }</span>
            <Switch
                checked={ checked }
                size='small'
                onChange={ () => {
                    props.onChange(!checked);
                    setChecked(!checked);
                } }
            />
        </Stack>
    );
}
export default EditableLabel;

export interface EditableLabelProps {
    readonly label: string;
    readonly initialChecked: boolean;
    readonly onChange: (checked: boolean) => any;
}